/**
 * 隐患整改模拟数据 — 字段对齐 safety_hazard_rectify / SafetyHazardRectifyEntity
 * 对接真实接口后可删除或仅保留字典标签。
 */
export const RECTIFY_STATUS_LABEL = {
  0: '待整改',
  1: '整改中',
  2: '已整改',
  3: '已关闭',
  4: '已取消'
}

export const ACCEPTANCE_LABEL = {
  0: '待验收',
  1: '验收通过',
  2: '验收不通过',
  3: '不适用'
}

const PROBLEM_TYPES = ['消防设施', '电气线路', '高处作业', '有限空间', '机械防护', '文明施工', '其他']
const DEPTS = ['安全环保部', '生产技术部', '机电车间', '储运车间', '外委单位']

function pad(n) {
  return n < 10 ? '0' + n : String(n)
}

/**
 * @param {number} count
 * @returns {object[]} 含 createTime/discoveryDate 毫秒时间戳，便于 moment
 */
export function createMockHazardRectifyList(count = 80) {
  const list = []
  const now = Date.now()
  for (let i = 0; i < count; i++) {
    const daysAgo = Math.floor(Math.pow(Math.random(), 1.1) * 40)
    const d = new Date(now - daysAgo * 86400000)
    d.setHours(8 + (i % 10), (i * 7) % 60, 0, 0)
    const discovery = d.getTime()
    const create = discovery + (Math.random() < 0.3 ? 3600000 : 0)
    const statusRoll = Math.random()
    let rectifyStatus =
      statusRoll < 0.22 ? 0 : statusRoll < 0.45 ? 1 : statusRoll < 0.72 ? 2 : statusRoll < 0.9 ? 3 : 4
    const reqEnd = new Date(discovery)
    reqEnd.setDate(reqEnd.getDate() + 3 + (i % 10))
    const overdue = reqEnd.getTime() < now && rectifyStatus !== 2 && rectifyStatus !== 3 && rectifyStatus !== 4
    if (overdue && Math.random() < 0.4) rectifyStatus = 1

    const typeName = PROBLEM_TYPES[i % PROBLEM_TYPES.length]
    const dept = DEPTS[i % DEPTS.length]
    const code = `YHBG-${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad((i % 999) + 1)}`

    let acceptanceResult = 3
    if (rectifyStatus === 2 || rectifyStatus === 3) {
      acceptanceResult = Math.random() < 0.85 ? 1 : 2
    } else if (rectifyStatus === 1) {
      acceptanceResult = 0
    }

    const rectifyDoneAt =
      rectifyStatus >= 2 ? discovery + (2 + (i % 5)) * 86400000 : null
    let acceptanceDate = null
    if (rectifyStatus >= 2 && acceptanceResult === 1) {
      acceptanceDate = rectifyDoneAt + (12 + (i % 48)) * 3600000
    } else if (rectifyStatus >= 2 && acceptanceResult === 2) {
      acceptanceDate = rectifyDoneAt + (6 + (i % 24)) * 3600000
    }

    list.push({
      id: 50000 + i,
      hazardCode: code,
      problemTypeName: typeName,
      responsibleDeptName: dept,
      rectifyPersonName: ['赵工', '钱工', '孙工', '李工', '周工'][i % 5],
      problemDescription: `${typeName}：${['巡检发现', '随手拍上报', '专项检查', '第三方指出'][i % 4]}，位置区域 ${(i % 8) + 1} 号点。`,
      rectifyStatus,
      discoveryDate: discovery,
      requiredCompletionDate: reqEnd.getTime(),
      rectifyCompletionDate: rectifyDoneAt,
      acceptanceResult,
      acceptancePersonName: rectifyStatus >= 2 && acceptanceResult === 1 ? '验收-王工' : '',
      acceptanceDate,
      updateTime: acceptanceDate || rectifyDoneAt || create,
      remark:
        rectifyStatus >= 2
          ? ['已更换部件', '增设警示标识', '完成培训交底', '现场已清理'][i % 4]
          : '',
      createTime: create,
      createName: ['上报人甲', '上报人乙', '上报人丙'][i % 3]
    })
  }
  return list.sort((a, b) => b.createTime - a.createTime)
}
